import { BREAKPOINTS } from 'javascripts/constants';
import iconButton from 'components/atoms/icon-button/icon-button';

export default class TeaserSpeakerToggle {
  constructor($teaserSpeaker, options = {}) {
    this.options = {
      openClass: 'teaser-speaker--open',
      toggleButtonClass: 'teaser-speaker__toggle-button',
      ...options,
    };

    this.teaserSpeaker = $teaserSpeaker;
    this.mql = window.matchMedia(`(min-width: ${BREAKPOINTS.l})`);
    this.$topWrapper = $teaserSpeaker.querySelector('.teaser-speaker__top-wrapper');

    // Binded events
    this.bindedClick = this.toggle.bind(this);
    this.bindedMql = this.onMediaQueryChange.bind(this);

    // Listen on media query changes
    this.mql.addEventListener('change', this.bindedMql);

    if (this.mql.matches) {
      this.deInit();
    } else {
      this.init();
    }
  }

  init() {
    this.teaserSpeaker.classList.remove(`${this.options.openClass}`);
    this.createToggleButton();
  }

  deInit() {
    this.teaserSpeaker.classList.remove(`${this.options.openClass}`);
    const toggleButton = this.teaserSpeaker.querySelector(`.${this.options.toggleButtonClass}`);
    if (toggleButton) {
      toggleButton.remove();
    }
  }

  createToggleButton(icon = 'open') {
    const $button = iconButton({
      icon,
      title: 'zurück nach oben',
      classes: `${this.options.toggleButtonClass}`,
    });

    $button.addEventListener('click', this.bindedClick);

    this.$topWrapper.append($button);
  }

  toggle() {
    const $toggleButton = this.teaserSpeaker.querySelector(`.${this.options.toggleButtonClass}`);
    $toggleButton.remove();

    this.teaserSpeaker.classList.toggle(`${this.options.openClass}`);

    if (this.teaserSpeaker.classList.contains(`${this.options.openClass}`)) {
      this.createToggleButton('minus');
    } else {
      this.createToggleButton('open');
    }
  }

  onMediaQueryChange() {
    if (this.mql.matches) {
      this.deInit();
    } else {
      this.init();
    }
  }
}

document.querySelectorAll('.js-teaser-speaker').forEach(
  $teaser => new TeaserSpeakerToggle($teaser),
);
